import React from "react";
import { QrCode } from "lucide-react";
import QRCodeStyling from "qr-code-styling";
import { Button } from "react-bootstrap";

import { tr } from "../../i18n";
const QRDownloadButton = ({
  qrUrl,
  fillText = "QR Code generated by",
  fileName = "qr-id.png",
  logo = "/logo192.png",
  compact = false,
  className = "",
}) => {
  const qrCode = new QRCodeStyling({
    width: 600,
    height: 600,
    type: "png",
    data: qrUrl,
    image: logo,
    dotsOptions: {
      color: "#0b0b0bff",
      type: "rounded",
    },
    cornersSquareOptions: {
      color: "#000000ff",
      type: "extra-rounded",
    },
    cornersDotOptions: {
      color: "#030303ff",
      type: "dot",
    },
    backgroundOptions: {
      color: "#f9fafb",
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 12,
      hideBackgroundDots: true,
    },
  });

  const handleDownload = async () => {
    const qrBlob = await qrCode.getRawData("png");
    const qrImage = await createImageBitmap(qrBlob);

    const padding = 40; // ruang kosong di sekitar QR
    const extraHeight = 120; // ruang ekstra untuk teks
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const width = qrImage.width + padding * 2;
    const height = qrImage.height + padding * 2 + extraHeight;
    canvas.width = width;
    canvas.height = height;

    // background putih keseluruhan
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);

    // gambar QR dengan padding
    ctx.drawImage(qrImage, padding, padding);

    // garis pemisah
    ctx.strokeStyle = "#d1d5db";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(60, qrImage.height + padding + 20);
    ctx.lineTo(width - 60, qrImage.height + padding + 20);
    ctx.stroke();

    // teks branding
    ctx.fillStyle = "#1e3a8a";
    ctx.font = "24px Arial";
    ctx.textAlign = "center";
    ctx.fillText(fillText, width / 2, qrImage.height + padding + 55);

    ctx.font = "bold 28px Arial";
    ctx.fillText("www.sewoork.com", width / 2, qrImage.height + padding + 95);

    // export png
    canvas.toBlob((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <Button
        variant="outline-primary"
        onClick={handleDownload}
        className={`d-flex align-items-center ${compact ? "justify-content-center" : "gap-2"} ${className}`}
        style={{
          fontSize: "11px",
          padding: compact ? "0" : "4px 8px",
          borderRadius: "6px",
          borderStyle: "solid",
          minWidth: compact ? "30px" : "auto",
          width: compact ? "30px" : "auto",
          height: compact ? "30px" : "auto",
        }}
        title={tr("users:download_qr")}
      >
        <QrCode size={14} />
        {!compact && tr("users:download")}
      </Button>
    </div>
  );
};

export default QRDownloadButton;
